export const ROUTES_TABLE_ROWS_PER_PAGE_OPTIONS = [10, 20, 25, 50, 100] as const;

export const ROUTES_TABLE_DEFAULT_PAGE_SIZE = 100;

export const ROUTES_TABLE_CARD_CLASS =
  'w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5';

export const ROUTES_TABLE_HEADER_CELL_SX = {
  fontSize: '1.125rem',
  py: 1.25,
} as const;

export const ROUTES_TABLE_BODY_CELL_SX = {
  fontSize: '1.125rem',
  py: 1.5,
} as const;

export const ROUTES_TABLE_BODY_ACTIONS_CELL_SX = {
  ...ROUTES_TABLE_BODY_CELL_SX,
  textAlign: 'right' as const,
};

export const ROUTES_TABLE_SKELETON_ACTIONS_PLACEHOLDER_CLASS =
  'inline-flex w-[120px] justify-end';
